import { render } from "./Onboarding.vue?vue&type=template&id=302ceaa8&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=302ceaa8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-302ceaa8"

export default script